import { IotahDevice } from './Iotah-device';
import { CharglinkDevice } from './charglink-device';
import { BattlinkDevice } from './battlink-device';
import { LithiumBattlinkDevice } from './lithium-battlink-device';
import { BattlinkIIDevice } from './battlink-ii-device';
import { DeviceConfig } from './device-config';
import { BrmDevice } from './brm-device';
import { eMeterDevice } from './eMeter-device';
import { iotemeterSp3 } from './iotEmeterSp3';
import { ioTEmeter } from './iotEmeter';
import { ioTEmeterEdge } from './iotEmeterEdge';

type Device = {
	application_type: number,
	sct_device_type: number
}

export class DeviceFactory {
	static readonly types = {
		iotah: 0,
		charglink: 1,
		battlink: 2,
		brm: 3,
		lithiumBattlink: 5,
		battlinkII: 6,
		ioTEmeterSp1: 100,
		ioTEmeterSp3: 101,
		ioTEmeter: 102,
		ioTEmeterEdge: 103
	};

	static readonly applicationTypes = {
		FORKLIFT: 0,
		POWER_STUDIES: 1,
		GOLF_CART: 2,
		BOAT: 3
	};

	static readonly typesString = {
		iotah: 'Truklink',
		charglink: 'ChargLink',
		study: 'Study',
		battlink: 'BattLink',
		lithiumBattlink: 'Lithium BATTlink',
		battlinkII: 'BATTlink II',
		brm: 'Brm',
		ioTEmeterSp1: 'IoTEmeter SP1',
		ioTEmeterSp3: 'IoTEmeter SP3',
		ioTEmeter: 'IoTEmeter Pro',
		ioTEmeterEdge: 'IoTEmeter Edge'
	};

	static readonly options = [
		{id: DeviceFactory.types.iotah, name: 'Truklink'},
		{id: DeviceFactory.types.charglink, name: 'CHARGlink'},
		{id: DeviceFactory.types.battlink, name: 'BATTlink'},
		{id: DeviceFactory.types.brm, name: 'BRM'},
		{id: DeviceFactory.types.lithiumBattlink, name: 'Lithium BATTlink'},
		{id: DeviceFactory.types.battlinkII, name: 'BATTlink II'},
	];

	static readonly ImeterOptionsType = [
		{id: DeviceFactory.types.ioTEmeterSp1, name: 'IoTEmeter SP1'},
		{id: DeviceFactory.types.ioTEmeterSp3, name: 'IoTEmeter SP3'},
		{id: DeviceFactory.types.ioTEmeter, name: 'IoTEmeter Pro'},
		{id: DeviceFactory.types.ioTEmeterEdge, name: 'IoTEmeter Edge'},
	];

	static readonly typesWithIncorrectEvents = [
		DeviceFactory.options[0], // Iotah
		DeviceFactory.options[1], // Charglink
		DeviceFactory.options[3], // Brm
	];

	static readonly PS_APPLICATION_TYPES = [
		{ id: DeviceFactory.applicationTypes.FORKLIFT, name: 'Forklift' },
		{ id: DeviceFactory.applicationTypes.POWER_STUDIES, name: 'Power Studies' },
		{ id: DeviceFactory.applicationTypes.GOLF_CART, name: 'Golf Cart' },
		{ id: DeviceFactory.applicationTypes.BOAT, name: 'Boat' }
	];

	static readonly chargerDeviceType = [
		{id: DeviceFactory.types.charglink, name: 'CHARGlink'},
		{id: DeviceFactory.types.brm, name: 'Brm'},
	];

	static createDevice(deviceType: number): DeviceConfig {
		switch (deviceType) {
			case DeviceFactory.types.iotah:
				return new IotahDevice();

			case DeviceFactory.types.charglink:
				return new CharglinkDevice();

			case DeviceFactory.types.battlink:
				return new BattlinkDevice();

			case DeviceFactory.types.lithiumBattlink:
				return new LithiumBattlinkDevice();

			case DeviceFactory.types.battlinkII:
				return new BattlinkIIDevice();

			case DeviceFactory.types.brm:
				return new BrmDevice();
			
			case DeviceFactory.types.ioTEmeterSp1:
				return new eMeterDevice();

			case DeviceFactory.types.ioTEmeterSp3:
				return new iotemeterSp3();

			case DeviceFactory.types.ioTEmeter:
				return new ioTEmeter();

			case DeviceFactory.types.ioTEmeterEdge:
				return new ioTEmeterEdge();

			default:
				throw new Error('Invalid device type');
		}
	}

	static group(devices: Device[], options: { getPowerStudyDevices: boolean } = { getPowerStudyDevices: false }) {
		const returnValue: { [key: string]: any[] } = {
			iotahDevices: [],
			charglinkdDevices: [],
			battlinkDevices: [],
			lithiumBattlinkDevices: [],
			battlinkIIDevices: [],
			brmDevices: [],
			ioTEmeterSp1: [],
			ioTEmeterSp3: [],
			ioTEmeter: [],
			ioTEmeterEdge: []
		};

		if (options.getPowerStudyDevices)
			returnValue.iotahPsDevices = [];

		for (const device of devices) {
			if (options.getPowerStudyDevices && device.application_type == this.applicationTypes.POWER_STUDIES && device.sct_device_type === DeviceFactory.types.iotah)
				returnValue.iotahPsDevices.push(device);

			else if (device.sct_device_type === DeviceFactory.types.charglink)
				returnValue.charglinkdDevices.push(device);

			else if (device.sct_device_type === DeviceFactory.types.battlink)
				returnValue.battlinkDevices.push(device);

			else if (device.sct_device_type === DeviceFactory.types.brm)
				returnValue.brmDevices.push(device);

			else if (device.sct_device_type === DeviceFactory.types.lithiumBattlink)
				returnValue.lithiumBattlinkDevices.push(device);

			else if (device.sct_device_type === DeviceFactory.types.battlinkII)
				returnValue.battlinkIIDevices.push(device);

			else if (device.sct_device_type === DeviceFactory.types.ioTEmeterSp1)
				returnValue.ioTEmeterSp1.push(device);

			else if (device.sct_device_type === DeviceFactory.types.ioTEmeterSp3)
				returnValue.ioTEmeterSp3.push(device);

			else if (device.sct_device_type === DeviceFactory.types.ioTEmeter)
				returnValue.ioTEmeter.push(device);

			else if (device.sct_device_type === DeviceFactory.types.ioTEmeterEdge)
				returnValue.ioTEmeterEdge.push(device);

			else
				returnValue.iotahDevices.push(device);
		}

		return returnValue;
	}

	static isIMDeviceType(deviceType: number): boolean {
		return this.ImeterOptionsType.some(value => value.id == deviceType);
	}

	static isChargerDeviceType(deviceType: number): boolean {
		return this.chargerDeviceType.some(value => value.id == deviceType);
	}

	static isBattlinkDeviceType(deviceType: number): boolean {
		return deviceType === this.types.battlink || deviceType === this.types.lithiumBattlink || deviceType === this.types.battlinkII;
	}
}
